<template>
    <section class="section">
      <div class="container">
        <h1 class="title">Página no encontrada</h1>
        <p class="subtitle">Lo sentimos, la página que buscas no existe.</p>
      </div>
    </section>
  </template>

  <script>
  export default {
    name: 'NotFound'
  }
  </script>